module.exports = __webpack_public_path__ + "img/point_festival_kv.982d9862.jpg";